export default __webpack_public_path__ + "static/media/monacco.00a7bc6b.png";